import { Fit } from 'types/fit'
import SavedFitConfirmationModal from '@components/FitFinder/SavedFit/SavedFitConfirmationModal'
type ReturnsSavedFitConfirmationModalProps = {
  savedFit?: Fit
  onClose?: () => void
}

export default function ReturnsSavedFitConfirmationModal({
  savedFit,
  onClose
}: ReturnsSavedFitConfirmationModalProps) {
  const title = 'Time to update your saved Fit?'
  const description =
    'You just returned a product - keep your Fit up to date for the best shopping experience.'

  if (!savedFit) return null  
  return (
    <SavedFitConfirmationModal
      method="return_portal"
      category="Returns portal"
      title={title}
      description={description}
      savedFit={savedFit}
      showFitFinderLink={false}
      onClose={onClose}
    />
  )
}
